import React from 'react';
import { CircularProgress, Box, Button } from '@material-ui/core';

const LoadableButton = ({ loading, disabled, children, ...props }) => {
  return (
    <Button {...props} disabled={disabled || loading}>
      {loading ? (
        <>
          <Box component='span' display='flex' mr={2}>
            <CircularProgress size={16} color='inherit' />
          </Box>
          {children}
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadableButton;
